import { useQuery } from '@tanstack/react-query';

import { OrderManagerApi } from '../api/orderManagerApi';

export const QUERY_KEY_SFTP_SETTINGS = 'om_sftp_settings';
export const useSftpSettings = () => {
  return useQuery([QUERY_KEY_SFTP_SETTINGS], OrderManagerApi.fetchSftpSettings);
};
